import * as e from "react";
const a = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 1a2 2 0 012 2v5.797l3 1.263V9a1 1 0 112 0v1.9l2.7 1.14c.18.08.3.26.3.46v2a.5.5 0 01-.6.49l-7.695-1.63-.552 4.416L15.8 19.88c.12.1.2.27.2.45v1.11c0 .37-.32.64-.64.54L12 20.9l-3.36 1.07v.01c-.32.1-.64-.17-.64-.54v-1.1c0-.19.08-.35.2-.46l2.647-2.103-.552-4.415L2.6 15a.5.5 0 01-.6-.49v-2c0-.2.12-.38.3-.46L5 10.9V9a1 1 0 012 0v1.06l3-1.264V3c0-1.1.9-2 2-2z",
      fill: "#2d6ded"
    }
  )
);
export {
  a as default
};
